import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';
const SvgFeatherOutlined = ({ size, title = 'FeatherOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8.138 8.91c3.255-3.255 11.586-4.634 11.586-4.634s-1.159 5.683-3.034 9.269l-2.373-.773.773 3.09c-3.807 3.807-8.221 1.27-8.221 1.27s-2.593-4.36 1.269-8.222z"
            clipRule="evenodd"
        />
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M10.345 13.655l-6.07 6.07"
        />
    </svg>
);
export default withIcon(SvgFeatherOutlined);
